import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.AGGREGATE_DATA_SET_AGGREGATE_DATA_LIST]: (state, payload) => {
    state.aggregateData = payload.aggregateList
  }
}

export default Mutations
